module.exports = __webpack_public_path__ + "img/meida.acfc4a2f.png";